module.exports = __webpack_public_path__ + "static/media/AFPILogo.7feba247.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AFPILogo.png
// module id = 687
// module chunks = 11